import LibrariesIndex from '@/views/LibrariesIndex.vue';
import LibrariesCreate from '@/views/LibrariesCreate.vue';
import LibrariesEdit from '@/views/LibrariesEdit.vue';

const routes = [
    {
        path: '/libraries',
        name: 'LibrariesIndex',
        component: LibrariesIndex,
        meta: { layout: 'DashboardLayout' }
    },
    {
        path: '/libraries/create',
        name: 'LibrariesCreate',
        component: LibrariesCreate,
        meta: { layout: 'DashboardLayout' }
    },
    {
        path: '/libraries/:id',
        name: 'LibrariesEdit',
        component: LibrariesEdit,
        meta: { layout: 'DashboardLayout' }
    }
];

export default routes
